import { httpClient } from '../../common/httpClient';
import { renderModel } from '../../util/renderModel';

let timeoutId = 0;

const { clientTopology } = renderModel.get();

export const markAsRead = async (conversationId?: string, lastMessageId?: string): Promise<void> => {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = 0;
  }
  if (lastMessageId && conversationId) {
    timeoutId = window.setTimeout(() => {
      httpClient.getInstance().put(clientTopology.markAsReadUrl, {
        lastMessageId,
        conversationId,
      });
      timeoutId = 0;
    }, 300);
  }
};
